module.exports = __webpack_public_path__ + "img/mintGreen.4f3bc8d2.png";